export const SPORT_TO_MARKET_MAP = {
	soccer: [
		"1st 10 Minutes Moneyline",
		"1st 10 Minutes Total Goals",
		"1st Half Anytime Goal Scorer",
		"1st Half Asian Handicap",
		"1st Half Asian Handicap Corners",
		"1st Half Asian Handicap Relative",
		"1st Half Asian Team Total",
		"1st Half Asian Total Goals",
		"1st Half Both Teams To Score",
		"1st Half Correct Score",
		"1st Half Double Chance",
		"1st Half Draw No Bet",
		"1st Half First Team To Score",
		"1st Half Goal Spread",
		"1st Half Goal Spread 3-Way",
		"1st Half Last Team To Score",
		"1st Half Moneyline",
		"1st Half Moneyline 3-Way",
		"1st Half Most Cards 3-Way",
		"1st Half Most Corners 3-Way",
		"1st Half Player Shots",
		"1st Half Player Shots On Target",
		"1st Half Team Clean Sheet",
		"1st Half Team To Score",
		"1st Half Team Total",
		"1st Half Team Total 3-Way",
		"1st Half Team Total Card Points",
		"1st Half Team Total Cards",
		"1st Half Team Total Corners",
		"1st Half Team Total Exact",
		"1st Half Team Total Fouls",
		"1st Half Team Total Goals",
		"1st Half Team Total Goals Odd/Even",
		"1st Half Team Total Odd/Even",
		"1st Half Team Total Offsides",
		"1st Half Team Total Shots",
		"1st Half Team Total Shots On Target",
		"1st Half Team Total Throw Ins",
		"1st Half Team Total Yellow Cards",
		"1st Half To Score",
		"1st Half Total Cards",
		"1st Half Total Corners",
		"1st Half Total Corners Odd/Even",
		"1st Half Total Fouls",
		"1st Half Total Goals",
		"1st Half Total Goals 3-Way",
		"1st Half Total Goals Exact",
		"1st Half Total Goals Odd/Even",
		"1st Half Total Offsides",
		"1st Half Total Shots",
		"1st Half Total Shots On Target",
		"1st Half Total Throw Ins",
		"1st Half Total Yellow Cards",
		"1st Half Will There Be A Red Card",
		"2nd Half Anytime Goal Scorer",
		"2nd Half Asian Handicap",
		"2nd Half Asian Handicap Cards",
		"2nd Half Asian Handicap Corners",
		"2nd Half Asian Handicap Relative",
		"2nd Half Asian Team Total",
		"2nd Half Asian Total Goals",
		"2nd Half Both Teams To Score",
		"2nd Half Correct Score",
		"2nd Half Double Chance",
		"2nd Half Draw No Bet",
		"2nd Half Goal Spread",
		"2nd Half Goal Spread 3-Way",
		"2nd Half Last Team To Score",
		"2nd Half Moneyline",
		"2nd Half Moneyline 3-Way",
		"2nd Half Most Cards 3-Way",
		"2nd Half Most Corners 3-Way",
		"2nd Half Team Clean Sheet",
		"2nd Half Team To Score",
		"2nd Half Team Total",
		"2nd Half Team Total 3-Way",
		"2nd Half Team Total Cards",
		"2nd Half Team Total Corners",
		"2nd Half Team Total Fouls",
		"2nd Half Team Total Goals",
		"2nd Half Team Total Goals Odd/Even",
		"2nd Half Team Total Odd/Even",
		"2nd Half Team Total Shots",
		"2nd Half Team Total Shots On Target",
		"2nd Half Team Total Yellow Cards",
		"2nd Half Total Cards",
		"2nd Half Total Corners",
		"2nd Half Total Corners Odd/Even",
		"2nd Half Total Fouls",
		"2nd Half Total Goals",
		"2nd Half Total Goals 3-Way",
		"2nd Half Total Goals Odd/Even",
		"2nd Half Total Offsides",
		"2nd Half Total Throw Ins",
		"2nd Half Total Yellow Cards",
		"2nd Half Will There Be A Red Card",
		"Anytime Card Receiver",
		"Anytime Goal Scorer",
		"Anytime Goal Scorer By Header",
		"Anytime Goal Scorer Outside Box",
		"Anytime Red Card Receiver",
		"Asian Handicap",
		"Asian Handicap Card Points",
		"Asian Handicap Cards",
		"Asian Handicap Corners",
		"Asian Handicap Relative",
		"Asian Team Total",
		"Asian Total Goals",
		"Both Teams To Score",
		"Both Teams To Score + Moneyline",
		"Both Teams To Score In At Least One Half",
		"Card Spread 3-Way",
		"Cards Handicap",
		"Corners Spread 3-Way",
		"Correct Score",
		"Double Chance",
		"Draw In Both Halves",
		"Draw No Bet",
		"First Card Receiver",
		"First Goal Scorer",
		"First Team To Score",
		"First Team To Score 3-Way",
		"Goal Both Halves",
		"Goal Spread",
		"Goal Spread 3-Way",
		"Halftime / Fulltime",
		"Highest Scoring Half",
		"Last Goal Scorer",
		"Last Team To Score",
		"Last Team To Score 3-Way",
		"Man Of The Match",
		"Moneyline",
		"Moneyline 3-Way",
		"Moneyline Reg Time",
		"Most Cards 3-Way",
		"Most Corners 3-Way",
		"Most Fouls 3-Way",
		"Most Shots 3-Way",
		"Most Shots On Target 3-Way",
		"Player Assists",
		"Player Blocked Shots",
		"Player Cards",
		"Player Chances Created",
		"Player Clearances",
		"Player Crosses",
		"Player Dribble Attempts",
		"Player Fouls",
		"Player Fouls Drawn",
		"Player Goals",
		"Player Goals + Assists",
		"Player Goals Against",
		"Player Interceptions",
		"Player Offsides",
		"Player Passes",
		"Player Passes Attempted",
		"Player Passes Attempted (Combo)",
		"Player Passes Completed",
		"Player Passing Attempts",
		"Player Passing Attempts (Combo)",
		"Player Saves",
		"Player Saves (Combo)",
		"Player Shots",
		"Player Shots (Combo)",
		"Player Shots Assisted",
		"Player Shots Attempted",
		"Player Shots On Goal",
		"Player Shots On Target",
		"Player Shots On Target (Combo)",
		"Player Tackles",
		"Player To Score Or Assist",
		"Race To 3 Corners",
		"Race To 5 Corners",
		"Race To 7 Corners",
		"Race To 9 Corners",
		"Run Line",
		"Second Goal Scorer",
		"Team Clean Sheet",
		"Team To Score",
		"Team To Score Both Halves",
		"Team To Win Both Halves",
		"Team To Win Either Half",
		"Team To Win To Nil",
		"Team Total",
		"Team Total 3-Way",
		"Team Total Card Points",
		"Team Total Cards",
		"Team Total Corners",
		"Team Total Exact",
		"Team Total Fouls",
		"Team Total Goal Minutes",
		"Team Total Goals",
		"Team Total Goals Exact",
		"Team Total Odd/Even",
		"Team Total Offsides",
		"Team Total Passing Attempts",
		"Team Total Reg Time",
		"Team Total Shots",
		"Team Total Shots On Target",
		"Team Total Tackles",
		"Team Total Throw Ins",
		"Third Goal Scorer",
		"To Lift The Cup",
		"To Qualify",
		"To Score A Penalty",
		"To Win To Nil",
		"Total Card Points",
		"Total Cards",
		"Total Cards Odd/Even",
		"Total Corners",
		"Total Corners 3-Way",
		"Total Corners Odd/Even",
		"Total Fouls",
		"Total Goal Minutes",
		"Total Goals",
		"Total Goals 3-Way",
		"Total Goals Exact",
		"Total Goals Odd/Even",
		"Total Offsides",
		"Total Red Cards",
		"Total Runs",
		"Total Shots",
		"Total Shots On Goal",
		"Total Shots On Target",
		"Total Throw Ins",
		"Will There Be A Penalty",
		"Will There Be A Red Card",
		"Will There Be An Own Goal",
		"Will There Be Overtime",
		"Winning Margin 5-Way",
	],
	hockey: [
		"1st 10 Minutes Moneyline",
		"1st 10 Minutes Moneyline 3-Way",
		"1st 10 Minutes Puck Line",
		"1st 10 Minutes Total Goals",
		"1st 5 Minutes Total Goals",
		"1st Period Anytime Goal Scorer",
		"1st Period Both Teams To Score",
		"1st Period Correct Score",
		"1st Period Double Chance",
		"1st Period First Goal Scorer",
		"1st Period First Team To Score",
		"1st Period First Team To Score 3-Way",
		"1st Period Last Goal Scorer",
		"1st Period Last Team To Score",
		"1st Period Last Team To Score 3-Way",
		"1st Period Moneyline",
		"1st Period Moneyline 3-Way",
		"1st Period Player Assists",
		"1st Period Player Goals",
		"1st Period Player Points",
		"1st Period Player Saves",
		"1st Period Player Shots On Goal",
		"1st Period Puck Line",
		"1st Period Team Total",
		"1st Period Team Total Power Play Goals",
		"1st Period Team Total Shots On Target",
		"1st Period Total Goals",
		"1st Period Total Goals Odd/Even",
		"1st Period Total Power Play Goals",
		"1st Period Total Shots On Target",
		"1st Quarter Team Total",
		"2nd Period Anytime Goal Scorer",
		"2nd Period Both Teams To Score",
		"2nd Period Correct Score",
		"2nd Period Double Chance",
		"2nd Period First Goal Scorer",
		"2nd Period First Team To Score",
		"2nd Period First Team To Score 3-Way",
		"2nd Period Last Goal Scorer",
		"2nd Period Last Team To Score",
		"2nd Period Last Team To Score 3-Way",
		"2nd Period Moneyline",
		"2nd Period Moneyline 3-Way",
		"2nd Period Player Saves",
		"2nd Period Player Shots On Goal",
		"2nd Period Puck Line",
		"2nd Period Team Total",
		"2nd Period Total Goals",
		"2nd Period Total Goals Odd/Even",
		"2nd Quarter Team Total",
		"3rd Period Anytime Goal Scorer",
		"3rd Period Both Teams To Score",
		"3rd Period Correct Score",
		"3rd Period Double Chance",
		"3rd Period First Goal Scorer",
		"3rd Period First Team To Score",
		"3rd Period First Team To Score 3-Way",
		"3rd Period Last Team To Score",
		"3rd Period Last Team To Score 3-Way",
		"3rd Period Moneyline",
		"3rd Period Moneyline 3-Way",
		"3rd Period Player Saves",
		"3rd Period Player Shots On Goal",
		"3rd Period Puck Line",
		"3rd Period Team Total",
		"3rd Period Total Goals",
		"3rd Period Total Goals Odd/Even",
		"3rd Quarter Team Total",
		"Anytime Goal Scorer",
		"Asian Handicap",
		"Asian Total Goals",
		"Both Teams To Score",
		"Both Teams To Score 2 Goals",
		"Both Teams To Score Reg Time",
		"Correct Score",
		"Correct Score Reg Time",
		"Double Chance",
		"Double Chance Reg Time",
		"Draw No Bet",
		"Draw No Bet Reg Time",
		"First Goal Scorer",
		"First Team To Score",
		"First Team To Score 3-Way",
		"Goal Spread",
		"Last Goal Scorer",
		"Last Team To Score",
		"Last Team To Score 3-Way",
		"Moneyline",
		"Moneyline 3-Way",
		"Moneyline Reg Time",
		"Player Assists",
		"Player Blocked Shots",
		"Player Blocks",
		"Player Faceoffs Won",
		"Player Fantasy Score",
		"Player Fantasy Score (All)",
		"Player Fantasy Score (Betr)",
		"Player Fantasy Score (Underdog)",
		"Player Goals",
		"Player Goals Against",
		"Player Hits",
		"Player Plus Minus",
		"Player Points",
		"Player Power Play Points",
		"Player Saves",
		"Player Saves (Combo)",
		"Player Shots",
		"Player Shots On Goal",
		"Player Shots On Goal (Combo)",
		"Player Shots On Goal + Blocked Shots",
		"Player Shots On Goal Reg Time",
		"Player Time On Ice",
		"Player To Record Shutout",
		"Point Spread",
		"Puck Line",
		"Puck Line Reg Time",
		"Second Goal Scorer",
		"Team To Score",
		"Team To Win To Nil",
		"Team Total",
		"Team Total Goals",
		"Team Total Odd/Even",
		"Team Total Power Play Goals",
		"Team Total Reg Time",
		"Team Total Shots",
		"Team Total Shots On Goal",
		"Team Total Shots On Target",
		"Third Goal Scorer",
		"To Win To Nil",
		"Total Goals",
		"Total Goals Odd/Even",
		"Total Goals Odd/Even Reg Time",
		"Total Goals Reg Time",
		"Total Power Play Goals",
		"Total Short Handed Goals",
		"Total Shots",
		"Total Shots On Goal",
		"Total Shots On Target",
		"Will There Be Overtime",
	],
	basketball: [
		"1st 3 Quarters Moneyline",
		"1st 3 Quarters Moneyline 3-Way",
		"1st 3 Quarters Point Spread",
		"1st 3 Quarters Total Points",
		"1st 5 Minutes Player Assists",
		"1st 5 Minutes Player Points",
		"1st 5 Minutes Player Points + Rebounds + Assists",
		"1st 5 Minutes Player Rebounds",
		"1st Half Double Chance",
		"1st Half Draw No Bet",
		"1st Half Moneyline",
		"1st Half Moneyline 3-Way",
		"1st Half Player Assists",
		"1st Half Player Fantasy Score (All)",
		"1st Half Player Fantasy Score (PrizePicks)",
		"1st Half Player Fantasy Score (SportsQuack)",
		"1st Half Player Free Throws Made",
		"1st Half Player Made Threes",
		"1st Half Player Points",
		"1st Half Player Points + Rebounds + Assists",
		"1st Half Player Rebounds",
		"1st Half Point Spread",
		"1st Half Point Spread 3-Way",
		"1st Half Race To 20 Points",
		"1st Half Race To 25 Points",
		"1st Half Race To 30 Points",
		"1st Half Race To 35 Points",
		"1st Half Race To 40 Points",
		"1st Half Race To 45 Points",
		"1st Half Race To 50 Points",
		"1st Half Race To 55 Points",
		"1st Half Race To 60 Points",
		"1st Half Race To 65 Points",
		"1st Half Race To 70 Points",
		"1st Half Race To 75 Points",
		"1st Half Race To 80 Points",
		"1st Half Team Total",
		"1st Half Team Total Odd/Even",
		"1st Half Total Points",
		"1st Half Total Points Odd/Even",
		"1st Quarter Double Chance",
		"1st Quarter Moneyline",
		"1st Quarter Moneyline 3-Way",
		"1st Quarter Player Assists",
		"1st Quarter Player Free Throws Made",
		"1st Quarter Player Points",
		"1st Quarter Player Points + Rebounds + Assists",
		"1st Quarter Player Rebounds",
		"1st Quarter Point Spread",
		"1st Quarter Race To 10 Points",
		"1st Quarter Race To 15 Points",
		"1st Quarter Race To 20 Points",
		"1st Quarter Race To 25 Points",
		"1st Quarter Race To 30 Points",
		"1st Quarter Race To 35 Points",
		"1st Quarter Race To 40 Points",
		"1st Quarter Team Total",
		"1st Quarter Team Total Odd/Even",
		"1st Quarter Total Points",
		"1st Quarter Total Points Odd/Even",
		"2nd Half Draw No Bet",
		"2nd Half Moneyline",
		"2nd Half Moneyline 3-Way",
		"2nd Half Moneyline 3-Way Reg Time",
		"2nd Half Moneyline Reg Time",
		"2nd Half Player Fantasy Score (All)",
		"2nd Half Player Fantasy Score (PrizePicks)",
		"2nd Half Player Made Threes",
		"2nd Half Player Points",
		"2nd Half Player Points + Rebounds + Assists",
		"2nd Half Point Spread",
		"2nd Half Point Spread Reg Time",
		"2nd Half Race To 40 Points",
		"2nd Half Race To 45 Points",
		"2nd Half Race To 50 Points",
		"2nd Half Race To 55 Points",
		"2nd Half Race To 60 Points",
		"2nd Half Team Total",
		"2nd Half Team Total Odd/Even",
		"2nd Half Total Points",
		"2nd Half Total Points Odd/Even",
		"2nd Half Total Points Reg Time",
		"2nd Quarter Moneyline",
		"2nd Quarter Moneyline 3-Way",
		"2nd Quarter Point Spread",
		"2nd Quarter Race To 10 Points",
		"2nd Quarter Race To 15 Points",
		"2nd Quarter Race To 20 Points",
		"2nd Quarter Race To 25 Points",
		"2nd Quarter Race To 30 Points",
		"2nd Quarter Team Total",
		"2nd Quarter Team Total Odd/Even",
		"2nd Quarter Total Points",
		"2nd Quarter Total Points Odd/Even",
		"3rd Quarter Moneyline",
		"3rd Quarter Moneyline 3-Way",
		"3rd Quarter Player Points",
		"3rd Quarter Point Spread",
		"3rd Quarter Race To 10 Points",
		"3rd Quarter Race To 15 Points",
		"3rd Quarter Race To 20 Points",
		"3rd Quarter Race To 25 Points",
		"3rd Quarter Race To 30 Points",
		"3rd Quarter Team Total",
		"3rd Quarter Team Total Odd/Even",
		"3rd Quarter Total Points",
		"3rd Quarter Total Points Odd/Even",
		"4th Quarter Moneyline",
		"4th Quarter Moneyline (incl OT)",
		"4th Quarter Moneyline 3-Way",
		"4th Quarter Player Fantasy Score (All)",
		"4th Quarter Player Fantasy Score (PrizePicks)",
		"4th Quarter Player Points",
		"4th Quarter Point Spread",
		"4th Quarter Point Spread (incl OT)",
		"4th Quarter Race To 10 Points",
		"4th Quarter Race To 15 Points",
		"4th Quarter Race To 20 Points",
		"4th Quarter Race To 25 Points",
		"4th Quarter Race To 30 Points",
		"4th Quarter Team Total",
		"4th Quarter Team Total Odd/Even",
		"4th Quarter Total Points",
		"4th Quarter Total Points (incl OT)",
		"4th Quarter Total Points Odd/Even",
		"Double Chance",
		"Draw No Bet",
		"First Basket",
		"First Basket Including FT",
		"First Team Basket",
		"First Team To Score",
		"First Team To Score Field Goal",
		"Halftime / Fulltime",
		"Highest Scoring Half",
		"Highest Scoring Quarter",
		"Last Team To Score",
		"Method Of First Basket",
		"Method Of First Basket Including FT",
		"Moneyline",
		"Moneyline 3-Way",
		"Moneyline Reg Time",
		"Player Assists",
		"Player Assists (Combo)",
		"Player Blocks",
		"Player Defensive Rebounds",
		"Player Double Double",
		"Player Dunks",
		"Player Fantasy Score (All)",
		"Player Fantasy Score (Betr)",
		"Player Fantasy Score (DraftKings)",
		"Player Fantasy Score (Hotstreak)",
		"Player Fantasy Score (ParlayPlay)",
		"Player Fantasy Score (PrizePicks)",
		"Player Fantasy Score (SportsQuack)",
		"Player Fantasy Score (Underdog)",
		"Player Field Goals Attempted",
		"Player Field Goals Made",
		"Player Fouls",
		"Player Free Throws Attempted",
		"Player Free Throws Made",
		"Player Made Threes",
		"Player Made Threes (Combo)",
		"Player Made Two Pointers",
		"Player Offensive Rebounds",
		"Player Points",
		"Player Points (Combo)",
		"Player Points + Assists",
		"Player Points + Rebounds",
		"Player Points + Rebounds + Assists",
		"Player Rebounds",
		"Player Rebounds (Combo)",
		"Player Rebounds + Assists",
		"Player Steals",
		"Player Steals + Blocks",
		"Player Threes Attempted",
		"Player Triple Double",
		"Player Turnovers",
		"Player Two Pointers Attempted",
		"Point Spread",
		"Point Spread 3-Way",
		"Race To 10 Points",
		"Race To 15 Points",
		"Race To 20 Points",
		"Race To 25 Points",
		"Race To 30 Points",
		"Race To 35 Points",
		"Race To 40 Points",
		"Race To 5 Points",
		"Race To 50 Points",
		"Race To 55 Points",
		"Race to 60 Points",
		"Race to 70 Points",
		"Race to 80 Points",
		"Race to 90 Points",
		"Team Total",
		"Team Total Assists",
		"Team Total Blocks",
		"Team Total Consecutive Points",
		"Team Total Made Threes",
		"Team Total Odd/Even",
		"Team Total Points Odd/Even",
		"Team Total Rebounds",
		"Team Total Steals",
		"Total Assists",
		"Total Blocks",
		"Total Consecutive Points",
		"Total Fouls",
		"Total Points",
		"Total Points Odd/Even",
		"Total Steals",
		"Will There Be Overtime",
		"Winning Margin 5-Way",
	],
	football: [
		"1st Half Anytime Touchdown Scorer",
		"1st Half Correct Score",
		"1st Half Double Chance",
		"1st Half Draw No Bet",
		"1st Half First Team To Score",
		"1st Half Moneyline",
		"1st Half Moneyline 3-Way",
		"1st Half Player Fantasy Score (All)",
		"1st Half Player Fantasy Score (PrizePicks)",
		"1st Half Player Passing Yards",
		"1st Half Player Receiving Yards",
		"1st Half Player Rushing Yards",
		"1st Half Point Spread",
		"1st Half Team Total",
		"1st Half Team Total Field Goals",
		"1st Half Team Total Odd/Even",
		"1st Half Team Total Touchdowns",
		"1st Half Total Field Goals",
		"1st Half Total Points",
		"1st Half Total Points Odd/Even",
		"1st Half Total Touchdowns",
		"1st Quarter Anytime Touchdown Scorer",
		"1st Quarter Double Chance",
		"1st Quarter Moneyline",
		"1st Quarter Moneyline 3-Way",
		"1st Quarter Player Receiving Yards",
		"1st Quarter Player Rushing Yards",
		"1st Quarter Point Spread",
		"1st Quarter Team Total",
		"1st Quarter Team Total Field Goals",
		"1st Quarter Team Total Odd/Even",
		"1st Quarter Team Total Touchdowns",
		"1st Quarter Total Field Goals",
		"1st Quarter Total Points",
		"1st Quarter Total Points Odd/Even",
		"1st Quarter Total Touchdowns",
		"2nd Half Anytime Touchdown Scorer",
		"2nd Half Correct Score",
		"2nd Half Double Chance",
		"2nd Half Draw No Bet",
		"2nd Half Moneyline",
		"2nd Half Moneyline 3-Way",
		"2nd Half Moneyline 3-Way Reg Time",
		"2nd Half Player Fantasy Score (All)",
		"2nd Half Player Fantasy Score (PrizePicks)",
		"2nd Half Point Spread",
		"2nd Half Point Spread Reg Time",
		"2nd Half Team Total",
		"2nd Half Team Total Field Goals",
		"2nd Half Team Total Touchdowns",
		"2nd Half Total Field Goals",
		"2nd Half Total Points",
		"2nd Half Total Points Odd/Even",
		"2nd Half Total Points Reg Time",
		"2nd Half Total Touchdowns",
		"2nd Quarter Moneyline",
		"2nd Quarter Moneyline 3-Way",
		"2nd Quarter Point Spread",
		"2nd Quarter Team Total",
		"2nd Quarter Team Total Field Goals",
		"2nd Quarter Team Total Odd/Even",
		"2nd Quarter Team Total Touchdowns",
		"2nd Quarter Total Field Goals",
		"2nd Quarter Total Points",
		"2nd Quarter Total Points Odd/Even",
		"2nd Quarter Total Touchdowns",
		"3rd Quarter Moneyline",
		"3rd Quarter Moneyline 3-Way",
		"3rd Quarter Point Spread",
		"3rd Quarter Team Total",
		"3rd Quarter Team Total Field Goals",
		"3rd Quarter Team Total Odd/Even",
		"3rd Quarter Team Total Touchdowns",
		"3rd Quarter Total Field Goals",
		"3rd Quarter Total Points",
		"3rd Quarter Total Points Odd/Even",
		"3rd Quarter Total Touchdowns",
		"4th Quarter Moneyline",
		"4th Quarter Moneyline (incl OT)",
		"4th Quarter Moneyline 3-Way",
		"4th Quarter Moneyline 3-Way (incl OT)",
		"4th Quarter Player Fantasy Score (All)",
		"4th Quarter Player Fantasy Score (PrizePicks)",
		"4th Quarter Point Spread",
		"4th Quarter Point Spread (incl OT)",
		"4th Quarter Team Total",
		"4th Quarter Team Total Field Goals",
		"4th Quarter Team Total Odd/Even",
		"4th Quarter Team Total Touchdowns",
		"4th Quarter Total Field Goals",
		"4th Quarter Total Points",
		"4th Quarter Total Points (incl OT)",
		"4th Quarter Total Points Odd/Even",
		"4th Quarter Total Touchdowns",
		"Anytime Touchdown Scorer",
		"Correct Score",
		"Draw No Bet",
		"First Team To Score",
		"First Touchdown Scorer",
		"Goal Spread",
		"Halftime / Fulltime",
		"Highest Scoring Half",
		"Highest Scoring Quarter",
		"Last Team To Score",
		"Last Touchdown Scorer",
		"Longest Touchdown Yards",
		"Moneyline",
		"Moneyline 3-Way",
		"Moneyline Reg Time",
		"Player Assists",
		"Player Defensive Interceptions",
		"Player Deflections",
		"Player Extra Points Made",
		"Player Fantasy Score (All)",
		"Player Fantasy Score (Betr)",
		"Player Fantasy Score (ParlayPlay)",
		"Player Fantasy Score (PrizePicks)",
		"Player Fantasy Score (Underdog)",
		"Player Field Goals Made",
		"Player Field Goals Made (Combo)",
		"Player First Downs",
		"Player Interceptions",
		"Player Kicking Points",
		"Player Longest Passing Completion",
		"Player Longest Reception",
		"Player Longest Rush",
		"Player Passes Completed",
		"Player Passing + Rushing Yards",
		"Player Passing Attempts",
		"Player Passing Completion Percentage",
		"Player Passing Completions",
		"Player Passing First Downs",
		"Player Passing Touchdowns",
		"Player Passing Yards",
		"Player Passing Yards (Combo)",
		"Player Punts",
		"Player Receiving Targets",
		"Player Receiving Touchdowns",
		"Player Receiving Yards",
		"Player Receiving Yards (Combo)",
		"Player Receptions",
		"Player Rushing + Receiving Yards",
		"Player Rushing + Receiving Yards (Combo)",
		"Player Rushing Attempts",
		"Player Rushing Touchdowns",
		"Player Rushing Yards",
		"Player Rushing Yards (Combo)",
		"Player Sacks",
		"Player Sacks Taken",
		"Player Tackles",
		"Player Tackles + Assists",
		"Player Touchdowns",
		"Player Touchdowns (Combo)",
		"Point Spread",
		"Point Spread 3-Way",
		"Race To 10 Points",
		"Race To 15 Points",
		"Race To 20 Points",
		"Race To 25 Points",
		"Race To 30 Points",
		"Race To 35 Points",
		"Race To 40 Points",
		"Race To 5 Points",
		"Team To Win Both Halves",
		"Team Total",
		"Team Total Field Goal Attempts",
		"Team Total Field Goals",
		"Team Total Odd/Even",
		"Team Total Passing Touchdowns",
		"Team Total Reg Time",
		"Team Total Rushing Touchdowns",
		"Team Total Sacks",
		"Team Total Touchdowns",
		"Total Field Goals",
		"Total Passing Touchdowns",
		"Total Points",
		"Total Points Odd/Even",
		"Total Punts",
		"Total Runs",
		"Total Rushing Touchdowns",
		"Total Sacks",
		"Total Touchdowns",
		"Total Turnovers",
		"Will There Be A Safety",
		"Will There Be Overtime",
	],
	baseball: [
		"1st 2 Innings Player Strikeouts",
		"1st 3 Innings Moneyline",
		"1st 3 Innings Moneyline 3-Way",
		"1st 3 Innings Player Earned Runs",
		"1st 3 Innings Player Strikeouts",
		"1st 3 Innings Run Line",
		"1st 3 Innings Team Total",
		"1st 3 Innings Total Runs",
		"1st 4 Innings Moneyline 3-Way",
		"1st 6 Innings Moneyline 3-Way",
		"1st 7 Innings Both Teams to Score",
		"1st 7 Innings Moneyline",
		"1st 7 Innings Moneyline 3-Way",
		"1st 7 Innings Run Line",
		"1st 7 Innings Team Total",
		"1st 7 Innings Total Runs",
		"1st Half Asian Handicap",
		"1st Half Both Teams To Score",
		"1st Half Correct Score",
		"1st Half Draw No Bet",
		"1st Half Moneyline",
		"1st Half Moneyline 3-Way",
		"1st Half Run Line",
		"1st Half Team Total",
		"1st Half Team Total Hits",
		"1st Half Team Total Odd/Even",
		"1st Half Total Hits",
		"1st Half Total Points",
		"1st Half Total Runs",
		"1st Inning Correct Score",
		"1st Inning Moneyline",
		"1st Inning Moneyline 3-Way",
		"1st Inning Most Hits 3-Way",
		"1st Inning Player Earned Runs",
		"1st Inning Player Hits",
		"1st Inning Player Hits + Runs + RBIs",
		"1st Inning Player Hits Allowed",
		"1st Inning Player Pitches Thrown",
		"1st Inning Player Runs",
		"1st Inning Player Strikeouts",
		"1st Inning Run Line",
		"1st Inning Team To Score",
		"1st Inning Team Total",
		"1st Inning Team Total Batters To Plate",
		"1st Inning Team Total Hits",
		"1st Inning Team Total Home Runs",
		"1st Inning Team Total Pitches Thrown",
		"1st Inning Team Total Strikeouts",
		"1st Inning To Score",
		"1st Inning Total Hits",
		"1st Inning Total Hits + Runs + Errors",
		"1st Inning Total Runs",
		"1st Inning Total Runs Exact",
		"1st Inning Total Runs Odd/Even",
		"2nd Inning Correct Score",
		"2nd Inning Moneyline",
		"2nd Inning Moneyline 3-Way",
		"2nd Inning Player Hits Allowed",
		"2nd Inning Player Pitches Thrown",
		"2nd Inning Player Strikeouts",
		"2nd Inning Run Line",
		"2nd Inning Team Total",
		"2nd Inning Team Total Batters To Plate",
		"2nd Inning Team Total Hits",
		"2nd Inning Team Total Pitches Thrown",
		"2nd Inning Team Total Strikeouts",
		"2nd Inning To Score",
		"2nd Inning Total Hits",
		"2nd Inning Total Runs",
		"2nd Inning Total Runs Exact",
		"2nd Inning Total Runs Odd/Even",
		"3rd Inning Correct Score",
		"3rd Inning Moneyline",
		"3rd Inning Moneyline 3-Way",
		"3rd Inning Player Hits Allowed",
		"3rd Inning Player Pitches Thrown",
		"3rd Inning Player Strikeouts",
		"3rd Inning Run Line",
		"3rd Inning Team Total",
		"3rd Inning Team Total Batters To Plate",
		"3rd Inning Team Total Hits",
		"3rd Inning Team Total Pitches Thrown",
		"3rd Inning Team Total Strikeouts",
		"3rd Inning To Score",
		"3rd Inning Total Hits",
		"3rd Inning Total Runs",
		"3rd Inning Total Runs Exact",
		"3rd Inning Total Runs Odd/Even",
		"4th Inning Correct Score",
		"4th Inning Moneyline",
		"4th Inning Moneyline 3-Way",
		"4th Inning Player Hits Allowed",
		"4th Inning Player Pitches Thrown",
		"4th Inning Player Strikeouts",
		"4th Inning Run Line",
		"4th Inning Team Total",
		"4th Inning Team Total Batters To Plate",
		"4th Inning Team Total Hits",
		"4th Inning Team Total Pitches Thrown",
		"4th Inning Team Total Strikeouts",
		"4th Inning To Score",
		"4th Inning Total Hits",
		"4th Inning Total Runs",
		"4th Inning Total Runs Exact",
		"4th Inning Total Runs Odd/Even",
		"5th Inning Correct Score",
		"5th Inning Moneyline",
		"5th Inning Moneyline 3-Way",
		"5th Inning Player Hits Allowed",
		"5th Inning Player Pitches Thrown",
		"5th Inning Player Strikeouts",
		"5th Inning Run Line",
		"5th Inning Team Total",
		"5th Inning Team Total Batters To Plate",
		"5th Inning Team Total Hits",
		"5th Inning Team Total Pitches Thrown",
		"5th Inning Team Total Strikeouts",
		"5th Inning To Score",
		"5th Inning Total Hits",
		"5th Inning Total Runs",
		"5th Inning Total Runs Exact",
		"5th Inning Total Runs Odd/Even",
		"6th Inning Correct Score",
		"6th Inning Moneyline",
		"6th Inning Moneyline 3-Way",
		"6th Inning Run Line",
		"6th Inning Team Total",
		"6th Inning Team Total Batters To Plate",
		"6th Inning Team Total Hits",
		"6th Inning Team Total Pitches Thrown",
		"6th Inning Team Total Strikeouts",
		"6th Inning To Score",
		"6th Inning Total Hits",
		"6th Inning Total Runs",
		"6th Inning Total Runs Exact",
		"6th Inning Total Runs Odd/Even",
		"7th Inning Correct Score",
		"7th Inning Moneyline",
		"7th Inning Moneyline 3-Way",
		"7th Inning Run Line",
		"7th Inning Team Total",
		"7th Inning Team Total Batters To Plate",
		"7th Inning Team Total Hits",
		"7th Inning Team Total Pitches Thrown",
		"7th Inning Team Total Strikeouts",
		"7th Inning To Score",
		"7th Inning Total Hits",
		"7th Inning Total Runs",
		"7th Inning Total Runs Exact",
		"7th Inning Total Runs Odd/Even",
		"8th Inning Correct Score",
		"8th Inning Moneyline",
		"8th Inning Moneyline 3-Way",
		"8th Inning Run Line",
		"8th Inning Team Total",
		"8th Inning Team Total Batters To Plate",
		"8th Inning Team Total Hits",
		"8th Inning Team Total Pitches Thrown",
		"8th Inning Team Total Strikeouts",
		"8th Inning To Score",
		"8th Inning Total Hits",
		"8th Inning Total Runs",
		"8th Inning Total Runs Exact",
		"8th Inning Total Runs Odd/Even",
		"9th Inning Correct Score",
		"9th Inning Moneyline",
		"9th Inning Moneyline 3-Way",
		"9th Inning Run Line",
		"9th Inning Team Total",
		"9th Inning Team Total Hits",
		"9th Inning Team Total Pitches Thrown",
		"9th Inning Team Total Strikeouts",
		"9th Inning To Score",
		"9th Inning Total Runs",
		"9th Inning Total Runs Exact",
		"9th Inning Total Runs Odd/Even",
		"Both Teams To Score",
		"Correct Score",
		"First Team To Score",
		"Halftime / Fulltime",
		"Highest Scoring Inning",
		"Last Team To Score",
		"Last Team To Score 3-Way",
		"Moneyline",
		"Moneyline 3-Way",
		"Most Hits 3-Way",
		"No Runs First Inning",
		"Player Bases",
		"Player Batting Fantasy Score (All)",
		"Player Batting Fantasy Score (Betr)",
		"Player Batting Fantasy Score (DraftKings)",
		"Player Batting Fantasy Score (PrizePicks)",
		"Player Batting Fantasy Score (SportsQuack)",
		"Player Batting Fantasy Score (Underdog)",
		"Player Batting Strikeouts",
		"Player Batting Walks",
		"Player Doubles",
		"Player Earned Runs",
		"Player Fantasy Score (All)",
		"Player Fantasy Score (DraftKings)",
		"Player Fantasy Score (ParlayPlay)",
		"Player Fantasy Score (Underdog)",
		"Player Hits",
		"Player Hits + Runs + RBIs",
		"Player Hits Allowed",
		"Player Home Runs",
		"Player Home Runs Yes/No",
		"Player Outs",
		"Player Pitches Thrown",
		"Player Pitching Fantasy Score (All)",
		"Player Pitching Fantasy Score (DraftKings)",
		"Player Pitching Fantasy Score (PrizePicks)",
		"Player Pitching Fantasy Score (SportsQuack)",
		"Player Pitching Fantasy Score (Underdog)",
		"Player RBIs",
		"Player Runs",
		"Player Runs + RBIs",
		"Player Singles",
		"Player Stolen Bases",
		"Player Strikeouts",
		"Player Strikeouts (Combo)",
		"Player To Record Win",
		"Player Triples",
		"Player Walks",
		"Run Line",
		"Run Line 3-Way",
		"Team Highest Scoring Inning 3-Way",
		"Team To Win Most Innings",
		"Team Total",
		"Team Total Hits",
		"Team Total Home Runs",
		"Team Total Odd/Even",
		"Total Bases",
		"Total Doubles",
		"Total Hits",
		"Total Hits + Runs + Errors",
		"Total Home Runs",
		"Total Home Runs Odd/Even",
		"Total Runs",
		"Total Runs 3-Way",
		"Total Runs Odd/Even",
		"Total Strikeouts",
		"Total Triples",
		"Will There Be Extra Innings",
		"Will There Be Overtime",
	],
	tennis: [
		"1st Set Correct Score",
		"1st Set Game Spread",
		"1st Set Game Spread 3-Way",
		"1st Set Moneyline",
		"1st Set Most Aces",
		"1st Set Player Aces",
		"1st Set Player Games Lost",
		"1st Set Player Games Won",
		"1st Set Total Aces",
		"1st Set Total Breaks",
		"1st Set Total Games",
		"1st Set Total Games Odd/Even",
		"2nd Set Correct Score",
		"2nd Set Game Spread",
		"2nd Set Game Spread 3-Way",
		"2nd Set Moneyline",
		"2nd Set Most Aces",
		"2nd Set Player Aces",
		"2nd Set Player Games Won",
		"2nd Set Total Aces",
		"2nd Set Total Games",
		"2nd Set Total Games Odd/Even",
		"3rd Set Correct Score",
		"3rd Set Game Spread",
		"3rd Set Moneyline",
		"3rd Set Most Aces",
		"3rd Set Player Aces",
		"3rd Set Player Games Won",
		"3rd Set Total Aces",
		"3rd Set Total Games",
		"3rd Set Total Games Odd/Even",
		"4th Set Correct Score",
		"4th Set Game Spread",
		"4th Set Moneyline",
		"4th Set Player Games Won",
		"4th Set Total Games",
		"4th Set Total Games Odd/Even",
		"5th Set Correct Score",
		"5th Set Game Spread",
		"5th Set Moneyline",
		"5th Set Player Games Won",
		"5th Set Total Games",
		"5th Set Total Games Odd/Even",
		"Both Players To Win A Set",
		"Correct Score",
		"Game Spread",
		"Game Spread 3-Way",
		"Go The Distance",
		"Moneyline",
		"Moneyline 3-Way",
		"Most Aces 3-Way",
		"Most Double Faults 3-Way",
		"Most Games Won 3-Way",
		"Player Aces",
		"Player Aces + Double Faults",
		"Player Break Points Won",
		"Player Double Faults",
		"Player Fantasy Score (All)",
		"Player Fantasy Score (PrizePicks)",
		"Player Fantasy Score (Underdog)",
		"Player First Serve Percentage",
		"Player Games Lost",
		"Player Games Won",
		"Player Service Games Lost",
		"Player Sets Lost",
		"Player Sets Won",
		"Player To Win A Set",
		"Point Spread",
		"Set Handicap",
		"Total Aces",
		"Total Break Points",
		"Total Breaks",
		"Total Double Faults",
		"Total Games",
		"Total Games 3-Way",
		"Total Games Odd/Even",
		"Total Points Odd/Even",
		"Total Sets",
		"Total Sets Odd/Even",
		"Total Tie Breaks",
	],
	esports: [
		"1st 2 Maps Player Assists",
		"1st 2 Maps Player Deaths",
		"1st 2 Maps Player Double Kills",
		"1st 2 Maps Player Fantasy Score (All)",
		"1st 2 Maps Player Fantasy Score (Underdog)",
		"1st 2 Maps Player Headshots",
		"1st 2 Maps Player Kills",
		"1st 2 Maps Player Kills (Combo)",
		"1st 2 Maps Player Penta Kills",
		"1st 2 Maps Player Quadra Kills",
		"1st 2 Maps Player Triple Kills",
		"1st 3 Maps Player Assists",
		"1st 3 Maps Player Deaths",
		"1st 3 Maps Player Double Kills",
		"1st 3 Maps Player Fantasy Score (Underdog)",
		"1st 3 Maps Player Goals",
		"1st 3 Maps Player Headshots",
		"1st 3 Maps Player Kills",
		"1st 3 Maps Player Kills (Combo)",
		"1st 3 Maps Player Penta Kills",
		"1st 3 Maps Player Quadra Kills",
		"1st 3 Maps Player Saves",
		"1st 3 Maps Player Triple Kills",
		"1st 4 Maps Player Demos",
		"1st 4 Maps Player Goals",
		"1st 4 Maps Player Saves",
		"1st Map Asian Handicap",
		"1st Map Correct Score",
		"1st Map First Elemental Dragon",
		"1st Map Handicap",
		"1st Map Kills Handicap",
		"1st Map Moneyline",
		"1st Map Player Assists",
		"1st Map Player Deaths",
		"1st Map Player Double Kills",
		"1st Map Player Fantasy Score (All)",
		"1st Map Player Fantasy Score (Underdog)",
		"1st Map Player Headshots",
		"1st Map Player Kills",
		"1st Map Player Kills (Combo)",
		"1st Map Player Penta Kills",
		"1st Map Player Quadra Kills",
		"1st Map Player Triple Kills",
		"1st Map Round Handicap",
		"1st Map Team Destroy First Inhibitor",
		"1st Map Team First Baron",
		"1st Map Team First Blood",
		"1st Map Team Total",
		"1st Map Team Total Kills",
		"1st Map Total Bombs Defused",
		"1st Map Total Inhibitors Destroyed",
		"1st Map Total Kills",
		"1st Map Total Kills Odd/Even",
		"1st Map Total Rounds",
		"1st Map Total Rounds Odd/Even",
		"1st Map Total Turrets Destroyed",
		"1st Map Will There Be Overtime",
		"2nd Map Asian Handicap",
		"2nd Map Correct Score",
		"2nd Map First Elemental Dragon",
		"2nd Map Handicap",
		"2nd Map Kills Handicap",
		"2nd Map Moneyline",
		"2nd Map Player Assists",
		"2nd Map Player Deaths",
		"2nd Map Player Fantasy Score (All)",
		"2nd Map Player Fantasy Score (Underdog)",
		"2nd Map Player Kills",
		"2nd Map Round Handicap",
		"2nd Map Team Destroy First Inhibitor",
		"2nd Map Team First Blood",
		"2nd Map Team Total",
		"2nd Map Team Total Kills",
		"2nd Map Total Bombs Defused",
		"2nd Map Total Inhibitors Destroyed",
		"2nd Map Total Kills",
		"2nd Map Total Kills Odd/Even",
		"2nd Map Total Rounds",
		"2nd Map Total Rounds Odd/Even",
		"2nd Map Total Turrets Destroyed",
		"2nd Map Will There Be Overtime",
		"3rd Map Asian Handicap",
		"3rd Map First Elemental Dragon",
		"3rd Map Handicap",
		"3rd Map Kills Handicap",
		"3rd Map Moneyline",
		"3rd Map Player Assists",
		"3rd Map Player Deaths",
		"3rd Map Player Fantasy Score (Underdog)",
		"3rd Map Player Headshots",
		"3rd Map Player Kills",
		"3rd Map Round Handicap",
		"3rd Map Team Destroy First Inhibitor",
		"3rd Map Team First Baron",
		"3rd Map Team First Blood",
		"3rd Map Team Total",
		"3rd Map Team Total Kills",
		"3rd Map Total Bombs Defused",
		"3rd Map Total Inhibitors Destroyed",
		"3rd Map Total Kills",
		"3rd Map Total Kills Odd/Even",
		"3rd Map Total Rounds",
		"3rd Map Total Rounds Odd/Even",
		"3rd Map Total Turrets Destroyed",
		"4th Map Handicap",
		"4th Map Kills Handicap",
		"4th Map Moneyline",
		"4th Map Player Deaths",
		"4th Map Player Headshots",
		"4th Map Player Kills",
		"4th Map Round Handicap",
		"4th Map Team Total",
		"4th Map Team Total Kills",
		"4th Map Total Kills",
		"4th Map Total Kills Odd/Even",
		"4th Map Total Rounds",
		"4th Map Total Rounds Odd/Even",
		"5th Map Handicap",
		"5th Map Kills Handicap",
		"5th Map Moneyline",
		"5th Map Player Deaths",
		"5th Map Player Headshots",
		"5th Map Player Kills",
		"5th Map Round Handicap",
		"5th Map Team Total",
		"5th Map Team Total Kills",
		"5th Map Total Kills",
		"5th Map Total Kills Odd/Even",
		"5th Map Total Rounds",
		"5th Map Total Rounds Odd/Even",
		"Asian Map Handicap",
		"Correct Score",
		"Map Handicap",
		"Moneyline",
		"Moneyline 3-Way",
		"Round Handicap",
		"Team Total Rounds",
		"Total Inhibitors Destroyed",
		"Total Kills",
		"Total Maps",
		"Total Maps Odd/Even",
		"Total Rounds",
		"Total Rounds Odd/Even",
		"Total Turrets Destroyed",
		"Will There Be Overtime",
	],
	mma: [
		"Draw No Bet",
		"Go The Distance",
		"Method of Victory",
		"Moneyline",
		"Moneyline 3-Way",
		"Player Fantasy Score (All)",
		"Player Fantasy Score (Betr)",
		"Player Fantasy Score (DraftKings)",
		"Player Fantasy Score (PrizePicks)",
		"Player Fantasy Score (Underdog)",
		"Player Fight Time Minutes",
		"Player Finishes",
		"Player Knockouts",
		"Player Significant Strikes",
		"Player Submissions",
		"Player Takedowns",
		"Player To Make Weight",
		"Point Spread",
		"Round Betting",
		"Total Rounds",
	],
	golf: [
		"10th Hole Player Relative Score",
		"11th Hole Player Relative Score",
		"12th Hole Player Relative Score",
		"13th Hole Player Relative Score",
		"14th Hole Player Relative Score",
		"15th Hole Player Relative Score",
		"16th Hole Player Relative Score",
		"17th Hole Player Relative Score",
		"18th Hole Player Relative Score",
		"1st 3 Holes Moneyline 3-Way",
		"1st 6 Holes Moneyline 3-Way",
		"1st Hole Moneyline 3-Way",
		"1st Hole Player Relative Score",
		"1st Round Handicap",
		"1st Round Moneyline",
		"2nd Hole Moneyline 3-Way",
		"2nd Hole Player Relative Score",
		"2nd Round Handicap",
		"2nd Round Moneyline",
		"3rd Hole Moneyline 3-Way",
		"3rd Hole Player Relative Score",
		"3rd Round Handicap",
		"3rd Round Moneyline",
		"4th Hole Moneyline 3-Way",
		"4th Hole Player Relative Score",
		"4th Round Handicap",
		"4th Round Moneyline",
		"5th Hole Moneyline 3-Way",
		"5th Hole Player Relative Score",
		"6th Hole Moneyline 3-Way",
		"6th Hole Player Relative Score",
		"7th Hole Moneyline 3-Way",
		"7th Hole Player Relative Score",
		"8th Hole Moneyline 3-Way",
		"8th Hole Player Relative Score",
		"9th Hole Moneyline 3-Way",
		"9th Hole Player Relative Score",
		"Handicap",
		"Moneyline",
		"Player Birdies Or Better",
		"Player Birdies Streak",
		"Player Bogeys Or Better",
		"Player Bogeys Or Worse",
		"Player Bounce Backs",
		"Player Cumulative Par 5 Strokes",
		"Player Eagles",
		"Player Fairways Hit",
		"Player Fantasy Score (All)",
		"Player Fantasy Score (DraftKings)",
		"Player Fantasy Score (Underdog)",
		"Player Greens In Regulation",
		"Player Holes Lost",
		"Player Holes Won",
		"Player Leaderboard Position",
		"Player Pars",
		"Player Pars Or Better",
		"Player Single Holes Lost",
		"Player Single Holes Won",
		"Player Strokes",
	],
	other: [],
};

// Popular markets shown as quick-pick chips: Moneyline, Spread, Total first, then sport-specific popular.
export const SPORT_TO_POPULAR_MARKETS = {
	basketball: [
		'Moneyline',
		'Point Spread',
		'Total Points',
		'Player Points',
		'Player Rebounds',
		'Player Assists',
		'1st Half Moneyline',
		'1st Half Point Spread',
		'1st Half Total Points',
	],
	baseball: [
		'Moneyline',
		'Run Line',
		'Total Runs',
		'Player Home Runs',
		'Player Hits',
		'Player Strikeouts',
		'1st Half Moneyline',
		'Team Total',
		'Total Hits',
	],
	soccer: [
		'Moneyline',
		'Goal Spread',
		'Total Goals',
		'Anytime Goal Scorer',
		'Asian Handicap',
		'Draw No Bet',
		'Both Teams To Score',
	],
	football: [
		'Moneyline',
		'Point Spread',
		'Total Points',
		'Anytime Touchdown Scorer',
		'Player Passing Yards',
		'Player Rushing Yards',
		'Player Receiving Yards',
		'1st Half Moneyline',
		'1st Half Point Spread',
		'1st Half Total Points',
	],
	hockey: [
		'Moneyline',
		'Puck Line',
		'Total Goals',
		'Player Goals',
		'Player Points',
		'1st Period Moneyline',
		'1st Period Puck Line',
		'1st Period Total Goals',
		'Player Shots On Goal',
	],
	tennis: [
		'Moneyline',
		'Set Handicap',
		'Total Games',
		'Game Spread',
		'1st Set Moneyline',
	],
	mma: [
		'Moneyline',
		'Round Handicap',
		'Total Rounds',
		'Method of Victory',
		'Go The Distance',
	],
	esports: [
		'Moneyline',
		'Map Handicap',
		'Total Maps',
		'1st Map Total Kills',
		'Total Kills',
		'1st Map Moneyline',
		'Map Betting',
	],
	golf: [
		'Moneyline',
		'Handicap',
		'To Qualify',
		'Player Birdies Streak',
		'Player Eagles',
		'1st Round Moneyline',
	],
	other: ['Moneyline', 'Point Spread', 'Total Points'],
};